
export const name = "notifications";
export const version = "dev";
